import { useEffect, useState } from 'react';
import { api } from '../api/client';
import type { PublicPlatformSettings } from '../lib/platformContact';

let cache: PublicPlatformSettings | null = null;
let inflight: Promise<PublicPlatformSettings> | null = null;

async function loadPlatformSettings(): Promise<PublicPlatformSettings> {
  if (cache) return cache;
  if (!inflight) {
    inflight = api
      .publicPlatformSettings()
      .then((row) => {
        cache = row as PublicPlatformSettings;
        return cache;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function invalidatePlatformSettingsCache() {
  cache = null;
}

export function usePlatformSettings() {
  const [settings, setSettings] = useState<PublicPlatformSettings | null>(cache);
  const [loading, setLoading] = useState(!cache);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(!cache);
    loadPlatformSettings()
      .then((row) => {
        if (!cancelled) {
          setSettings(row);
          setError(null);
        }
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : 'Failed');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { settings, loading, error };
}
